/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type LandingPageTargetCreateRequest = {
    bootCampCategory?: LandingPageTargetCreateRequest.bootCampCategory;
    sequence?: number;
    contents?: string;
    image?: Blob;
    alt?: string;
};

export namespace LandingPageTargetCreateRequest {

    export enum bootCampCategory {
        ALL = 'ALL',
        SEBFE = 'SEBFE',
        SEBBE = 'SEBBE',
        UUB = 'UUB',
        GMB = 'GMB',
        DOB = 'DOB',
        PMB = 'PMB',
        BEB = 'BEB',
        AIB = 'AIB',
    }


}

